import React from 'react'
import { connect } from 'react-redux'
import { avatarType } from 'common/types'
import { isGold, getSex, getMedia } from 'utils'
import { T } from 'components/Translations'
import StyledAvatar from './StyledAvatar'

import man from 'assets/avatar/normal-man.svg'
import woman from 'assets/avatar/normal-woman.svg'
import notApproved from 'assets/avatar/not-approved.svg'

const hash = string => string.split('').reduce((a, b) => (a + b.charCodeAt(0)) % 10, 0)

const calculateSrc = ({ src, sex, type, trial }) => {
  if (src.match(/notapproved/)) {
    return notApproved
  }
  if (src.match(/nophoto/)) {
    return sex == 1 ? man : woman
  }
  if (type == 'xxx' && trial) {
    return `/theme/photos/photo_xxx_adult_${sex == 1 ? '' : 'wo'}man_${hash(src)}.png`
  }
  return src
}

const Avatar = ({ trial, user, size, mediaIndex, source, filter, mine, basic, className = '' }) => {
  const { previewUri, uri, adultRating } = getMedia(user, source, mediaIndex)
  let src = (previewUri || uri || '').replace('{0}', size.replace(/responsive|large/, ''))
  const type = !src || mine || adultRating <= filter ? 'normal' : adultRating == 3 ? 'xxx' : 'sexy'
  src = calculateSrc({ src, sex: getSex(user), type, trial })

  const withFilter = uri?.match(/nophoto|notapproved/) ? 'with-filter' : ''

  if (basic) {
    return <img className={`avatar ${className} ${withFilter}`} src={uri} />
  }

  return (
    <StyledAvatar className={`avatar ${className}`} {...{ size, type, mine, trial, src }}>
      <div className={`avatar-img ${withFilter}`} style={{ backgroundImage: src ? `url(${src})` : 'none' }}></div>
      <div className="avatar-text">{/sexy|xxx/.test(type) && type}</div>
      {trial && type == 'xxx' && size == 'responsive' && (
        <T as="div" className="avatar-upgrade" label="membership/upgradeForXxx" />
      )}
    </StyledAvatar>
  )
}

Avatar.propTypes = avatarType

Avatar.defaultProps = {
  size: 'responsive',
  source: 'user',
}

export default connect(s => ({ filter: s.myProfile.adultRatingId, trial: !isGold(s.myProfile) }))(Avatar)
